import admin from '@/apps/admin/lang/en'
import brelag from '@/apps/brelag/common/lang/en'
import components from '@/lang/lang-en/components'
import models from '@/lang/lang-en/models'

const apps = {
  admin,
  brelag,
}

export default {
  components,
  models,
  apps,
}
